import { IconButton } from "../IconButton/IconButton";
import { API_DOMAIN, PROTOCOL } from "../../globals";
import React, { useCallback } from "react";

export default function FAQButton() {
  const openFaq = useCallback(() => {
    window.open("https://dockethealth.com/faqs", "_blank");
  }, []);

  return (
    <>
      <IconButton icon="faq" onClick={openFaq} alt={"FAQ"} className="max-md:hidden" />
      <img
        src="/assets/images/circle_question.svg"
        alt="FAQ"
        className="md:hidden w-[24px] h-[24px]"
        onClick={openFaq}
      />
    </>
  );
}
